import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { CheckIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import type { IValidationError } from "features/editor/types";

export const Validation = ({
  validationErrors,
  onValidationErrorClick,
}: {
  validationErrors: IValidationError[];
  onValidationErrorClick: (event: React.SyntheticEvent) => void;
}) => {
  if (!validationErrors?.length) {
    return null;
  }

  const label = validationErrors?.length ? "Text is invalid." : "Text is valid.";

  return (
    <Tooltip title={label}>
      <IconButton onClick={onValidationErrorClick}>
        {validationErrors?.length ? (
          <ExclamationTriangleIcon width={18} height={18} className="status--error cursor--pointer" />
        ) : (
          <CheckIcon width={16} height={16} className="status--success" />
        )}
      </IconButton>
    </Tooltip>
  );
};
